import { Box, BoxProps, Text } from 'roo-ui/components';
import PulsingLoadingBlock from 'components/PulsingLoadingBlock';
import { useBookingListContext } from '../contextProvider/BookingListContextProvider';

type StylingProps = BoxProps;

const BookingListResultSummary = (props: StylingProps) => {
  const { loading, bookingCountLabel } = useBookingListContext();

  return (
    <Box data-testid="booking-list-result-summary" {...props}>
      {loading && <PulsingLoadingBlock mt={0} mb={0} height="24px" width="140px" />}
      {!loading && (
        <Text fontSize="18px" color="emperor">
          {bookingCountLabel}
        </Text>
      )}
    </Box>
  );
};

export default BookingListResultSummary;
